export class PopupService {
    async addError(error) {
        const newMessage = {
            value: error
        };
        this.showPopup(newMessage);
    }
    showPopup(newMessage) {
        if (this.kitchen !== null) {
            this.kitchen.push({
                label: newMessage.value,
                dismissButton: true,
                timeoutMs: 3000
            });
        }
    }
    async registerAddHandler(kitchen) {
        this.kitchen = kitchen;
    }
}
